import React, { useMemo, useState,useEffect } from "react";
import { Button } from "../../components/Button";
import OfficeLocationsModal from "../location/OfficeLocationsModal";
import { Edit, Edit2, LayoutGrid, List, LocateOffIcon, Pencil, Plus, RefreshCcw, Trash2 } from "lucide-react";
import { toast } from "react-toastify";
import gstApi from "../../api/gstApi";
import { useSelector } from "react-redux";
import officeLocationApi from "../../api/officeLocationApi";
import LocationInfoClient from "../../components/clients/LocationInfoClient";
import { FiMapPin } from "react-icons/fi";
import { confirmSubmit } from "../../utils/confirmSubmit";

const VIEW_KEY = "locations_view_mode";

const LocationsTab = ({ selectedClientData, onCreate, businessInfoId,onRefreshAccounts}) => {
    // const locations =
    //     selectedClientData?.businessInformation?.locations || [];
const businessInformationId = selectedClientData?.businessInformation.id
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [viewMode, setViewMode] = useState(
        () => localStorage.getItem(VIEW_KEY) || "grid"
    );

    // const gstList = selectedClientData?.businessInformation?.gstRegistrations || [];
    const [isOpen, setIsOpen] = useState(false);
    const [showCreateGst, setShowCreateGst] = useState(false);
    const [isGstId, setIsGstId] = useState(null);
    const [locations, setLocations] = useState(null);

    const token = useSelector((state) => state.auth.access_token);
    const [isUpdateBasic, setIsUpdateBasic] = useState({
        id: null,
        address: "",
        city: "",
        state: "",
        pincode: "",
        locationType: "",
    });
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const safeTrim = (value) => (value || "").trim();

    const fetchLocation = async() =>{
        try {
            const res = await officeLocationApi.getOfficeLocations(businessInformationId,token);
           setLocations(res.data)
        } catch (error) {
            console.log("location error : ",error)
        }
    }
    useEffect(() => {
    fetchLocation();
    }, [])
    
    const [filters, setFilters] = useState({
        locationType: "all",
        state: "all",
        city: "all",
      });
    
      const filteredTasks = useMemo(() => {
        if (!locations) return [];
    
        let tasks = [...locations];
    
        // Filter
        if (filters.state !== "all") {
          tasks = tasks.filter(
            (task) => task?.state === filters.state
          );
        }
        if (filters.city !== "all") {
          tasks = tasks.filter(
            (task) => task?.city === filters.city
          );
        }
        if (filters.locationType !== "all") {
          tasks = tasks.filter(
            (task) => task?.locationType === filters.locationType
          );
        }
    
        return tasks;
      }, [locations, filters]);
    
      const getState = [
        ...new Set(
          locations
            ?.map((t) => t?.state)
            .filter(Boolean)
        ),
      ];
      const getCity = [
        ...new Set(
          locations
            ?.map((t) => t?.city)
            .filter(Boolean)
        ),
      ];
      const getLocationType = [
        ...new Set(
          locations
            ?.map((t) => t?.locationType)
            .filter(Boolean)
        ),
      ];

    const validateForm = () => {
        const newErrors = {};

        const city = isUpdateBasic?.city?.trim();
        const state = isUpdateBasic?.state?.trim();
        const pincode = isUpdateBasic?.pincode?.trim();
        const locationType = isUpdateBasic?.locationType?.trim();
        const address = isUpdateBasic?.address?.trim();

        if (!city) {
            newErrors.city = "City is required";
        }

        if (!state) {
            newErrors.state = "State is required";
        }

        if (!pincode) {
            newErrors.pincode = "Pincode is required";
        } else if (!/^[0-9]{6}$/.test(pincode)) {
            newErrors.pincode = "Pincode must be exactly 6 digits";
        }

        if (!locationType) {
            newErrors.locationType = "Location Type is required";
        }

        if (!address) {
            newErrors.address = "Address is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors)?.length === 0;
        };


    const handelUpdate = async (e) => {
        e.preventDefault();
        if (selectedClientData?.businessInformation === null) {
            toast.error('Please first Add Business Information then Add Office Locations details');
            return;
        }
        if (!validateForm()) {
            toast.error('Please complete existing Location details first');
            return;
        }
      try {
        setIsLoading(true);
        if (isGstId) {
            await officeLocationApi.updateOfficeLocation(isUpdateBasic?.id, isUpdateBasic, token);
            toast.success("Location Update Successfully!");
            setIsUpdateBasic({
                id: null,
                address: "",
                city: "",
                state: "",
                pincode: "",
                locationType: "",
                });
            onRefreshAccounts();
            fetchLocation();
            setIsLoading(false);
            setShowCreateGst(false);
            setIsGstId(null);
        }else{
            await officeLocationApi.createOfficeLocation(selectedClientData?.businessInformation?.id, isUpdateBasic, token);
            toast.success("Location New Successfully!");
            setIsUpdateBasic({
                id: null,
                address: "",
                city: "",
                state: "",
                pincode: "",
                locationType: "",
                });
            onRefreshAccounts();
            fetchLocation();
            setIsLoading(false);
            setShowCreateGst(false);
            setIsGstId(null);
        }
      } catch (error) {
        console.error("Error fetching location:", error);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    };
    const handelDelete = async (e, id) => {
        e.preventDefault();
       
const confirmed = await confirmSubmit({
          title: "Confirm location delete",
          text: "Are you sure you want to delete this location?",
          confirmText: "Submit",
        });
        if (!confirmed) return;
      try {
        setIsLoading(true);
            await officeLocationApi.deleteOfficeLocation(id, token);
            toast.success("GST Registration Delete Successfully!");
            setIsUpdateBasic({
                id: null,
                address: "",
                city: "",
                state: "",
                pincode: "",
                locationType: "",
                });
            fetchLocation();
            onRefreshAccounts();
            setIsLoading(false);
            setShowCreateGst(false);
            setIsGstId(null);
      } catch (error) {
        console.error("Error fetching location:", error);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    };

    // const handleViewChange = (mode) => {
    //     setViewMode(mode);
    //     localStorage.setItem(VIEW_KEY, mode);
    // };

    const truncateWords = (text, maxWords = 3) => {
    if (!text) return "-";
    const words = text.trim().split(/\s+/);
    return words?.length > maxWords
        ? words.slice(0, maxWords).join(" ") + "..."
        : text;
    };

     const [sortConfig, setSortConfig] = useState({
      key: null,
      direction: "asc", // asc | desc
    });
  
    const handleSort = (key) => {
      setSortConfig((prev) => {
        if (prev.key === key) {
          return {
            key,
            direction: prev.direction === "asc" ? "desc" : "asc",
          };
        }
        return { key, direction: "asc" };
      });
    };
  
    const getValueByPath = (obj, path) =>
        path.split(".").reduce((acc, key) => acc?.[key], obj);
  
  
      const sortedTasks = useMemo(() => {
        if (!sortConfig.key) return filteredTasks;
  
        return [...filteredTasks].sort((a, b) => {
          const aVal = getValueByPath(a, sortConfig.key);
          const bVal = getValueByPath(b, sortConfig.key);
  
          if (!aVal) return 1;
          if (!bVal) return -1;
  
          if (typeof aVal === "string") {
            return sortConfig.direction === "asc"
              ? aVal.localeCompare(bVal)
              : bVal.localeCompare(aVal);
          }
  
          return sortConfig.direction === "asc"
            ? aVal > bVal ? 1 : -1
            : aVal < bVal ? 1 : -1;
        });
      }, [filteredTasks, sortConfig]);
  
  
    const SortIcon = ({ column }) => {
      const isActive = sortConfig.key === column;
  
      return (
        <span className="inline-flex flex-col ml-1 text-[9px] leading-none">
          <span
            className={
              isActive && sortConfig.direction === "asc"
                ? "text-gray-900"
                : "text-gray-300"
            }
          >
            ▲
          </span>
          <span
            className={
              isActive && sortConfig.direction === "desc"
                ? "text-gray-900"
                : "text-gray-300"
            }
          >
            ▼
          </span>
        </span>
      );
    };


    return (
        <div className="space-y-2 bg-white p-2 rounded-lg">
            <div className="flex items-start justify-between">
                <h2 className="text-xl font-semibold">Office Locations</h2>
                <button
                    type="button"
                    onClick={() => setShowCreateGst(true)}
                    className="bg-primary text-white px-3 py-1 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2 w-full sm:w-auto"
                >
                    <Plus className="h-4 w-4" />
                    <span>Add Location</span>
                </button>
            </div>

            {locations?.length !== 0 ? 
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-2 mt-1">
                <select
                    className="border rounded-lg px-3 py-1 text-sm"
                    value={filters.locationType}
                    onChange={(e) =>
                    setFilters({ ...filters, locationType: e.target.value })
                    }
                >
                    <option value="all">All Location Type</option>
                    {getLocationType.map((p, idx) => (
                    <option key={idx} value={p}>
                        {p}
                    </option>
                    ))}
                </select>
                <select
                    className="border rounded-lg px-3 py-1 text-sm"
                    value={filters.state}
                    onChange={(e) =>
                    setFilters({ ...filters, state: e.target.value })
                    }
                >
                    <option value="all">All State</option>
                    {getState.map((p, idx) => (
                    <option key={idx} value={p}>
                        {p}
                    </option>
                    ))}
                </select>
                <select
                    className="border rounded-lg px-3 py-1 text-sm"
                    value={filters.city}
                    onChange={(e) =>
                    setFilters({ ...filters, city: e.target.value })
                    }
                >
                    <option value="all">All City</option>
                    {getCity.map((p, idx) => (
                    <option key={idx} value={p}>
                        {p}
                    </option>
                    ))}
                </select>

                <div className="flex items-end justify-end">
                    <button
                        type="button"
                        onClick={() => setFilters({
                        locationType: "all",
                        state: "all",
                        city: "all",
                        })}
                        className="bg-primary py-1 px-2 rounded-md text-sm font-medium text-white hover:bg-primary [&:active_span]:animate-spin-once"
            >
                <span className="inline-block">
                                   <RefreshCcw size={18} />
                                 </span>
                    </button>
                </div>
            </div> : <></>}

            {/* <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-900">
                    Office Locations
                </h2>

                <div className="flex items-center space-x-2">
                    <button
                        onClick={() => handleViewChange("grid")}
                        className={`p-2 rounded ${
                            viewMode === "grid"
                                ? "bg-blue-100 text-blue-600"
                                : "text-gray-500 hover:bg-gray-100"
                        }`}
                        title="Grid View"
                    >
                        <LayoutGrid size={18} />
                    </button>

                    <button
                        onClick={() => handleViewChange("list")}
                        className={`p-2 rounded ${
                            viewMode === "list"
                                ? "bg-blue-100 text-blue-600"
                                : "text-gray-500 hover:bg-gray-100"
                        }`}
                        title="List View"
                    >
                        <List size={18} />
                    </button>
                </div>
            </div> */}

            {/* EMPTY STATE */}
            {/* {locations.length === 0 && (
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 text-center">
                    <p className="text-gray-600 mb-4">
                        No office locations found for this business.
                    </p>
                    <Button
                        onClick={() => setIsModalOpen(true)}
                        label="Add Office Location"
                    />
                </div>
            )} */}

            {/* GRID VIEW (Existing card layout – unchanged) */}
            {/* {viewMode === "grid" &&
                locations.map((location) => (
                    <div
                        key={location.id}
                        className="bg-white rounded-lg shadow-sm border border-gray-200 px-6 py-1"
                    >
                        <div className="flex items-center justify-between mb-1">
                            <h3 className="text-lg font-semibold text-gray-900">
                                {location.locationType}
                            </h3>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    State
                                </label>
                                <p className="text-sm text-gray-900">
                                    {location.state}
                                </p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    City
                                </label>
                                <p className="text-sm text-gray-900">
                                    {location.city}
                                </p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Address
                                </label>
                                <p className="text-sm text-gray-900">
                                    {location.address}
                                </p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Pincode
                                </label>
                                <p className="text-sm text-gray-900">
                                    {location.pincode}
                                </p>
                            </div>
                        </div>
                    </div>
                    
                ))} */}

            {filteredTasks?.length !== 0 ? 
            (<div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 text-sm">
                    <thead className="bg-gray-50">
                    <tr>
                        <th className="px-2 py-1 text-left text-slate-700">#</th>
                        <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("locationType")}><span className="flex flex-row items-center gap-1">Location Type <SortIcon column="locationType" /></span></th>
                        <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("state")}><span className="flex flex-row items-center gap-1">State <SortIcon column="state" /></span></th>
                        <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("city")}><span className="flex flex-row items-center gap-1">City <SortIcon column="city" /></span></th>
                        <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("address")}><span className="flex flex-row items-center gap-1">Address <SortIcon column="address" /></span></th>
                        <th className="px-2 py-1 text-center">Actions</th>
                    </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                    {sortedTasks.map((task, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                        <td className="px-2 py-1">{index + 1}</td>
                        <td className="px-2 py-1 font-medium">{task.locationType}</td>
                        <td className="px-2 py-1">{task?.state}</td>
                        <td className="px-2 py-1">{task?.city}</td>
                        <td className="px-2 py-1">{truncateWords(task?.address, 3)}</td>
                        <td className="px-2 py-1 text-center space-x-1">
                            <button
                                onClick={() => {setIsUpdateBasic(task); setIsGstId(task?.id); setShowCreateGst(true);}}
                                className="text-blue-600 hover:text-blue-900"
                            >
                                <Edit className="h-4 w-4" />
                            </button>
                            <button
                                onClick={(e) => handelDelete(e, task?.id)}
                                className="text-red-600 hover:text-red-900"
                            >
                                <Trash2 className="h-4 w-4" />
                            </button>
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>): (
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 text-center">
                    <FiMapPin className="h-12 w-12 text-gray-500 mx-auto mb-4" />
                    <p className="text-gray-600 mb-4">
                        No office locations found for this business.
                    </p>
                    {/* <Button
                        onClick={() => setIsModalOpen(true)}
                        label="Add Office Location"
                    /> */}
                </div>
                )}


            {showCreateGst && 
            <div onClick={() => setShowCreateGst(false)} className="fixed -top-6 inset-0 bg-black/40 flex items-center justify-center">
            <LocationInfoClient isGstId={isGstId} handelUpdate={handelUpdate} showCreateGst={showCreateGst} setShowCreateGst={setShowCreateGst} isLoading={isLoading} errors={errors} formData={isUpdateBasic} setFormData={setIsUpdateBasic} />
            </div>}

            {/* {viewMode === "list" && locations.length > 0 && (
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 overflow-x-auto">
                    <table className="min-w-full border-collapse">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
                                    Type
                                </th>
                                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
                                    State
                                </th>
                                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
                                    City
                                </th>
                                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
                                    Address
                                </th>
                                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">
                                    Pincode
                                </th>
                                <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">
                                    Actions
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {locations.map((location) => (
                                <tr
                                    key={location.id}
                                    className="border-t hover:bg-gray-50"
                                >
                                    <td className="px-4 py-2 text-sm">
                                        {location.locationType}
                                    </td>
                                    <td className="px-4 py-2 text-sm">
                                        {location.state}
                                    </td>
                                    <td className="px-4 py-2 text-sm">
                                        {location.city}
                                    </td>
                                    <td className="px-4 py-2 text-sm">
                                        {location.address}
                                    </td>
                                    <td className="px-4 py-2 text-sm">
                                        {location.pincode}
                                    </td>
                                    <td className="px-4 py-2 text-center">
                                        <div className="flex justify-center space-x-2">
                                            <button
                                                onClick={() =>
                                                    setIsModalOpen(true)
                                                }
                                                className="text-blue-600 hover:text-blue-800"
                                                title="Edit"
                                            >
                                                <Pencil size={16} />
                                            </button>

                                            <button
                                                className="text-red-600 hover:text-red-800"
                                                title="Delete"
                                            >
                                                <Trash2 size={16} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )} */}

            <OfficeLocationsModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                businessInfoId={businessInfoId}
                initialData={locations}
                onRefreshAccounts={onRefreshAccounts}
                onSave={(updated) =>
                    console.log("Updated locations:", updated)
                }
            />
        </div>
    );
};

export default LocationsTab;
